import { tCaseComponentsLib } from '@/Interfaces/caseComponentsLib';

export const drawers: tCaseComponentsLib = [
    {
        id: 'tcf_42x45',
        xmlId: '43b83876-d61b-017e-8d41-666b28a23e67',
        name: 'Ящик выдвижной малый TCF 42x45',
        type: 'drawer',
        caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2' ],
        blenderName: 'drawerS_tcf_42x45',
        image: 'dist/src/img/tcf_42x45.png',
    },
    {
        id: 'tcf_87x45',
        xmlId: 'b6cd369a-c9bb-a359-a2a8-e5acd30adc34',
        name: 'Ящик выдвижной большой TCF 87x45',
        type: 'drawer',
        caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2' ],
        blenderName: 'drawerL_tcf_87x45',
        image: 'dist/src/img/tcf_87x45.png',
    },
    {
        id: 'amh_tc_60',
        xmlId: '0c58cc0b-3d4b-9399-47e3-36c0a7df2216',
        name: 'Ящик AMH TC 60',
        type: 'drawer',
        caseModels: [ 'AMH-TC', 'AMH-TC-EL' ],
        blenderName: 'drawer_amh_tc_60',
        image: 'dist/src/img/amh_tc_60.png',
    },
    {
        id: 'amh_tc_125',
        xmlId: 'ebbc0f0e-9628-0f2e-549b-bcf3ebd30a7b',
        name: 'Ящик AMH TC 125',
        type: 'drawer',
        caseModels: [ 'AMH-TC', 'AMH-TC-EL' ],
        blenderName: 'drawer_amh_tc_125',
        image: 'dist/src/img/amh_tc_125.png',
    },
    {
        id: 'dr_hard_60',
        xmlId: 'b8bc23e1-f41f-3322-ac1f-a14fdfd84db5',
        name: 'Ящик HARD 60',
        type: 'drawer',
        caseModels: [ 'HARD-1000', 'HARD-2000' ],
        blenderName: 'drawer_hard_60',
        image: 'dist/src/img/dr_hard_60.png',
    },
    {
        id: 'dr_hard_125',
        xmlId: '11c4727e-48ed-dfeb-8d8b-370ec22e6add',
        name: 'Ящик HARD 125',
        type: 'drawer',
        caseModels: [ 'HARD-1000', 'HARD-2000' ],
        blenderName: 'drawer_hard_125',
        image: 'dist/src/img/dr_hard_125.png',
    },
    {
        id: 'dr_hard_265',
        xmlId: 'a091ab5f-66b4-bea6-fcd0-b5191bd025ef',
        name: 'Ящик HARD 265',
        type: 'drawer',
        caseModels: [ 'HARD-1000', 'HARD-2000' ],
        blenderName: 'drawer_hard_265',
        image: 'dist/src/img/dr_hard_265.png',
    },
    {
        id: 'tcf_39x45',
        xmlId: '785131f6-ce33-4a51-633c-ea35a2057e2d',
        name: 'TC ящик выдвижной TCF 39x45',
        type: 'drawer',
        caseModels: [ 'TC-1947' ],
        blenderName: 'drawer_tcf_39x45',
        image: 'dist/src/img/tcf_39x45.png',
    },
];
